export default __webpack_public_path__ + "static/media/45_mobile.68ae796a.jpg";